import { useEffect, useState } from 'react'

const MS_IN_MINUTE = 1000 * 60
const MS_IN_HOUR = MS_IN_MINUTE * 60
const MS_IN_DAY = MS_IN_HOUR * 24

const getDeclension = (value: number, one: string, two: string, five: string): string => {
	const lastDigit = value % 10
	const lastTwoDigits = value % 100

	if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return five
	if (lastDigit === 1) return one
	if (lastDigit >= 2 && lastDigit <= 4) return two

	return five
}

const buildCountdownText = (activeTo?: string | null, countdownText: string = `осталось`): string | null => {
	if (!activeTo) return null

	const target = new Date(activeTo).getTime()

	if (Number.isNaN(target)) return null

	const distance = target - Date.now()
	if (distance <= 0) return null

	const days = Math.floor(distance / MS_IN_DAY)
	const hours = Math.floor((distance % MS_IN_DAY) / MS_IN_HOUR)
	const minutes = Math.floor((distance % MS_IN_HOUR) / MS_IN_MINUTE)

	if (days >= 1) {
		return `${countdownText} ${days} ${getDeclension(days, 'день', 'дня', 'дней')}`
	}

	if (hours <= 0 && minutes <= 0) {
		return `${countdownText} меньше минуты`
	}

	const parts: string[] = []

	if (hours > 0) {
		parts.push(`${hours} ${getDeclension(hours, 'час', 'часа', 'часов')}`)
	}

	if (minutes > 0) {
		parts.push(`${minutes} ${getDeclension(minutes, 'минута', 'минуты', 'минут')}`)
	}

	return `${countdownText} ${parts.join(' ')}`
}

export const useTagTimer = (activeTo?: string | null, countdownText?: string): string | null => {
	const [text, setText] = useState<string | null>(() => buildCountdownText(activeTo, countdownText))

	useEffect(() => {
		if (!activeTo) {
			setText(null)
			return
		}

		const update = () => {
			const nextText = buildCountdownText(activeTo, countdownText)
			setText(nextText)
			return nextText
		}

		const initialText = update()
		if (!initialText) return

		const intervalId = setInterval(() => {
			const nextText = update()
			if (!nextText) {
				clearInterval(intervalId)
			}
		}, MS_IN_MINUTE)

		return () => clearInterval(intervalId)
	}, [activeTo, countdownText])

	return text
}
